exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".data-table{background:#f8f8f8;height:auto;width:auto;border-radius:5px;border:none;box-shadow:0 4px #e5e6e6}.data-table th{font-weight:800;font-size:16px;color:#7f8c8c;background:#ececec;padding:5px 15px;box-shadow:0 3px #e5e6e6;border-right:1px solid #ddd;text-align:left}.data-table th:first-child{border-radius:5px 0 0}.data-table th:last-of-type{border-radius:0 5px 0 0;border-right:none}.data-table td{color:#777;font-size:14px;border-right:1px solid #ddd;border-bottom:1px solid #e5e6e6;padding:10px 15px}.data-table td:last-of-type{border-right:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1764ea5e","scoped":false,"hasInlineConfig":true}!./src/components/data-table/data-table.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-1764ea5e","scoped":false,"hasInlineConfig":true}!./src/components/data-table/data-table.css
// module chunks = index